import { render, staticRenderFns } from "./RevenuePerUnit.vue?vue&type=template&id=74484dc2&scoped=true&"
import script from "./RevenuePerUnit.vue?vue&type=script&lang=ts&"
export * from "./RevenuePerUnit.vue?vue&type=script&lang=ts&"
import style0 from "./RevenuePerUnit.vue?vue&type=style&index=0&id=74484dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74484dc2",
  null
  
)

export default component.exports